module.exports = __webpack_public_path__ + "static/media/BY.853e5ddb.svg";